import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import hpeBgImg from "../assets/hpe-bg.jpg";
import { setTaxonomyDataRequest } from "../actions/TaxonomyActions";
import { validateEmail } from "./GlobalSettings";

class LoginCustomerForgotPasswd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      resetPasswordErrorText: undefined,
      newCustomerRegister: {"PassportEmailID": null, "userType": "3" },
      disableLoginButton: true,
      validEmailAccount: false,
      cust_email: undefined
  }

    this._HPEOnBackClick = this._HPEOnBackClick.bind(this);
    this._HandleForgotPasswordClick = this._HandleForgotPasswordClick.bind(this);
    this._HandleEmailChange = this._HandleEmailChange.bind(this);
  }

  componentDidMount() {}
  _HPEOnBackClick() {
    this.props.history.goBack();
  }

  _HandleEmailChange(event){
    if (validateEmail(event.target.value)){
      this.setState({cust_email: event.target.value, validEmailAccount: true, disableLoginButton: false})
    }
    else{
      this.setState({cust_email: undefined, validEmailAccount: false, disableLoginButton: true});
      }
    }
  

  _HandleForgotPasswordClick(){

    if(this.state.cust_email && this.state.validEmailAccount){
      var usrReset = this.state.newCustomerRegister;

      usrReset.PassportEmailID = this.state.cust_email;
      this.setState({newCustomerRegister: usrReset})
      this.props.resetReqCallBack(this.state.newCustomerRegister);
    }

  }

  render() {

    var ToDisable = true;

    if(this.state.cust_email && this.state.validEmailAccount){
      ToDisable = false;
    }


    return (
      <Box fill="vertical" align="stretch" justify="start">
        {/* <Header
          align="center"
          direction="row"
          flex={false}
          justify="between"
          gap="medium"
          background={{ color: "blue", dark: true }}
        >
          <Button icon={<Hpe />} color="brand" />
          <Menu icon={<More />} />
        </Header> */}
        <Main
          overflow="auto"
          background={{
            image: `url(${hpeBgImg})`,
            color: "background",
            dark: true,
          }}
          flex
          align="center"
          justify="center"
        >
          <Box
            align="center"
            justify="center"
            background={{ color: "background", dark: false }}
            pad="medium"
            round="xsmall"
            gap="medium"
          >
            <Heading level="1" size="small" margin="none">
              HPE Demonstration Portal
            </Heading>
            <Paragraph margin="none">
              Please provide your email address to start the Password Reset
              process.
            </Paragraph>
            <Box align="center" justify="center" gap="small">
              <TextInput placeholder="Enter Passport account email" name="CustomerEmail" onChange={(event) => {this._HandleEmailChange(event)}} />
            </Box>
            <Box align="center" justify="center" gap="medium" direction="row">
              <Button
                label="Back"
                primary={false}
                secondary
                onClick={this.props.hide}
              />
              <Button label="Reset Password" primary disabled = {ToDisable} onClick={this._HandleForgotPasswordClick} />
            </Box>
            <Paragraph>
              For the best user experience, we recommend Chrome
            </Paragraph>
          </Box>
        </Main>
      </Box>
    );
  }
}

export default withRouter(LoginCustomerForgotPasswd);
